import React from "react";

const CarDetailsModal = ({
  show,
  onClose,
  car,
  loading = false,
  error = "",
  tt = (key, fallback) => fallback,
  getCarImage,
  getFeatures,
  onBook,
}) => {
  if (!show) return null;

  return (
    <div
      className="professional-car-overlay"
      onClick={onClose}
    >
      <div
        className="professional-car-modal"
        onClick={(e) => e.stopPropagation()}
      >

        {/* =====================================================
            HEADER
        ===================================================== */}
        <div className="professional-car-header">

          <div className="professional-car-header-text">

            <div className="professional-car-eyebrow">
              {tt(
                "vehicleInformation",
                "VEHICLE INFORMATION"
              )}
            </div>

            <h2 className="professional-car-title">
              {car?.name ||
                car?.car_name ||
                car?.carmodel_name ||
                tt("carDetails", "Car Details")}

              <div className="professional-car-subtitle">
                {car?.category ||
                  car?.car_category ||
                  car?.group_name ||
                  ""}
              </div>
            </h2>

          </div>

          <button
            type="button"
            className="professional-car-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>

        </div>


        {/* =====================================================
            BODY
        ===================================================== */}
        <div className="professional-car-body">

          {/* LOADING */}
          {loading && (
            <div className="professional-car-loading">

              <div className="professional-spinner"></div>

              <div>
                {tt(
                  "loadingCarDetails",
                  "Loading car details..."
                )}
              </div>

            </div>
          )}


          {/* ERROR */}
          {!loading && error && (
            <div className="professional-car-error">
              {error}
            </div>
          )}


          {/* =================================================
              CAR DETAILS
          ================================================= */}
          {!loading && car && !error && (
            <>

              {/* =================================================
                  TOP SECTION
              ================================================= */}
              <div className="professional-car-top">

                {/* IMAGE */}
                <div className="professional-car-image-section">

                  <div className="professional-car-image-box">

                    <img
                      src={getCarImage(
                        car.image ||
                          car.carmodel_image ||
                          car.car_image
                      )}
                      alt={
                        car.name ||
                        car.model ||
                        "Car"
                      }
                      className="professional-car-image"
                    />

                  </div>
				  
      {/* =================================================
                  DESCRIPTION
              ================================================= */}
              {(car.description ||
                car.details ||
                car.content) && (

                <div className="professional-description">

                  <div className="professional-description-title">
                    {tt(
                      "description",
                      "Description"
                    )}
                  </div>

                  <div className="professional-description-text">
                    {car.description ||
                      car.details ||
                      car.content}
                  </div>

                </div>

              )}
                </div>


                {/* =================================================
                    SPECIFICATIONS
                ================================================= */}
                <div className="professional-car-spec-section">

                  <div className="professional-section-title">

                    <span className="professional-section-icon">
                      🚗
                    </span>

                    <span>
                      {tt(
                        "vehicleSpecifications",
                        "Vehicle Specifications"
                      )}
                    </span>

                  </div>


                  <div className="professional-spec-grid">

                    {/* PASSENGERS */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        👤
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "passengers",
                            "Passengers"
                          )}
                        </div>

                        <div className="professional-spec-value">
                          {car.passengers ??
                            car.persons ??
                            car.carmodel_passgrno ??
                            "-"}
                        </div>

                      </div>

                    </div>


                    {/* LUGGAGE */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        🧳
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "luggage",
                            "Luggage"
                          )}
                        </div>

                        <div className="professional-spec-value">
                          {car.luggage ??
                            car.bags ??
                            car.carmodel_luggno ??
                            "-"}
                        </div>

                      </div>

                    </div>


                    {/* TRANSMISSION */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        ⚙️
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "transmission",
                            "Transmission"
                          )}
                        </div>

                        <div className="professional-spec-value">
                          {car.transmission ||
                            car.gearbox ||
                            car.carmodel_transmission ||
                            "-"}
                        </div>

                      </div>

                    </div>


                    {/* AIR CONDITIONING */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        ❄️
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "airConditioning",
                            "Air Conditioning"
                          )}
                        </div>

                        <div className="professional-spec-value">

                          {(car.airConditioning ??
                            car.air_conditioning ??
                            car.airco ??
                            car.air_condition)
                            ? tt("yes", "Yes")
                            : tt("no", "No")}

                        </div>

                      </div>

                    </div>


                    {/* DOORS */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        🚪
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "doors",
                            "Doors"
                          )}
                        </div>

                        <div className="professional-spec-value">
                          {car.doors || "-"}
                        </div>

                      </div>

                    </div>


                    {/* ENGINE */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        🔧
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "engineCapacity",
                            "Engine Capacity"
                          )}
                        </div>

                        <div className="professional-spec-value">
                          {car.engineCapacity ??
                            car.engine_capacity ??
                            "-"}
                        </div>

                      </div>

                    </div>


                    {/* CENTRAL LOCKING */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        🔒
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "centralLocking",
                            "Central Locking"
                          )}
                        </div>

                        <div className="professional-spec-value">

                          {(car.centralLocking ??
                            car.central_locking)
                            ? tt("yes", "Yes")
                            : tt("no", "No")}

                        </div>

                      </div>

                    </div>


                    {/* AIRBAG */}
                    <div className="professional-spec-card">

                      <div className="professional-spec-icon">
                        🛡️
                      </div>

                      <div>

                        <div className="professional-spec-label">
                          {tt(
                            "airbag",
                            "Airbag"
                          )}
                        </div>

                        <div className="professional-spec-value">

                          {car.airbag
                            ? tt("yes", "Yes")
                            : tt("no", "No")}

                        </div>

                      </div>

                    </div>

                    {/* Stereo */}        
                      <div className="professional-spec-card">

                        <div className="professional-spec-icon">
                        ⚙️
                        </div>

                        <div>

                          <div className="professional-spec-label">
                            {tt(
                              "stereo",
                              "Stereo"
                            )}
                          </div>

                          <div className="professional-spec-value">

                            {car.stereo
                              ? tt("yes", "Yes")
                              : tt("no", "No")}

                          </div>

                        </div>

                      </div>
                    {/* Electric windows */}          
                      <div className="professional-spec-card">

                        <div className="professional-spec-icon">
                        🪟
                        </div>

                        <div>

                          <div className="professional-spec-label">
                            {tt(
                              "electric windows",
                              "Electric Windows"
                            )}
                          </div>

                          <div className="professional-spec-value">
                            {car.electricWindows
                              ? tt("yes", "Yes")
                              : tt("no", "Now")}

                          </div>

                        </div>

                      </div>

                  </div>


                  {/* =================================================
                      INCLUDED FEATURES
                  ================================================= */}
                  <div className="professional-included-section">

                    <div className="professional-section-title">

                      <span className="professional-section-icon included-icon">
                        ✓
                      </span>

                      <span>
                        {tt(
                          "includedFeatures",
                          "Included Features"
                        )}
                      </span>

                    </div>


                    <div className="professional-feature-grid">

                      {(() => {

                        const detailFeatures =
                          getFeatures
                            ? getFeatures(car)
                            : [];

                        const defaultFeatures = [
                          tt(
                            "noExtraCost",
                            "No Extra Cost"
                          ),
                          tt(
                            "allInclusive",
                            "All inclusive"
                          ),
                          tt(
                            "noGuarantee",
                            "No guarantee"
                          ),
                          tt(
                            "noCreditCard",
                            "No credit card required"
                          ),
                          tt(
                            "freeDelivery",
                            "Free delivery all over Crete"
                          ),
                          tt(
                            "freeRoadmap",
                            "Free roadmap of Crete"
                          ),
                          tt(
                            "unlimitedMileage",
                            "Unlimited mileage"
                          ),
                          tt(
                            "roadAssistance",
                            "24/7 road assistance"
                          ),
                          tt(
                            "fullInsurance",
                            "Full insurance!!"
                          )
                        ];

                        const features =
                          detailFeatures.length > 0
                            ? detailFeatures
                            : defaultFeatures;

                        return features.map(
                          (feature, index) => (

                            <div
                              className="professional-feature-card"
                              key={`feature-${index}`}
                            >

                              <span className="professional-feature-check">
                                ✓
                              </span>

                              <span className="professional-feature-text">
                                {feature}
                              </span>

                            </div>

                          )
                        );

                      })()}

                    </div>

                  </div>

                </div>

              </div>


             

            </>
          )}


          {/* NO DETAILS */}
          {!loading &&
            !car &&
            !error && (

              <div className="professional-no-details">

                {tt(
                  "noCarDetailsFound",
                  "No car details found."
                )}

              </div>

            )}

        </div>


        {/* =====================================================
            FOOTER
        ===================================================== */}
        {!loading && car && !error && (

          <div className="professional-car-footer">

            <div className="professional-footer-note">

              <span className="professional-footer-icon">
                🔐
              </span>

              <span>
                {tt(
                  "vehicleNote",
                  "Vehicle specifications may vary slightly depending on the actual vehicle provided."
                )}
              </span>

            </div>


            <div className="professional-footer-actions">

              <button
                type="button"
                className="button1 professional-close-button"
                onClick={onClose}
              >
                {tt(
                  "close",
                  "Close"
                )}
              </button>


              <button
                type="button"
                className="button2 professional-book-button"
                onClick={() => {
                  onClose();

                  if (onBook) {
                    onBook(car);
                  }
                }}
              >
                {tt(
                  "bookThis",
                  "BOOK THIS"
                )}
              </button>

            </div>

          </div>

        )}

      </div>
    </div>
  );
};

export default CarDetailsModal;